import { ColDef } from 'ag-grid-community'
import { ApiVariableMultiplier } from 'api/_legacy/generated-api'
import clsx from 'clsx'
import {
  AssetNameCell,
  Card,
  ColDefWithLoading,
  LoadingTable,
  Table,
  Tabs
} from 'components/core-v2'
import { useParams } from 'react-router-dom'

import {
  ApiFixedMultiplier,
  useGetByTenantAccountAndAccountSourceAccountIdentifierQuery
} from '@/api'
import { TENANT } from '@/const'

import classes from './index.module.scss'

export const COLUMN_DEFS: ColDefWithLoading[] = [
  {
    headerName: 'Performance asset',
    field: 'name',
    minWidth: 200,
    flex: 0.8,
    cellRenderer: AssetNameCell,
    loadingCellWidth: 'xl'
  },
  {
    headerName: 'Multiplier',
    field: 'multiplier',
    minWidth: 140,
    flex: 0.1
  },
  {
    headerName: 'Weight',
    field: 'weight',
    minWidth: 140,
    flex: 0.1,
    type: 'rightAligned'
  }
]

export const DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: true,
  unSortIcon: true
}

export const TradeRiskPortfolioTab = () => {
  const { source, tradeId } = useParams()
  const { data, isLoading } = useGetByTenantAccountAndAccountSourceAccountIdentifierQuery({
    tenant: TENANT,
    accountIdentifier: tradeId,
    accountSource: source
  })

  if (isLoading) {
    return (
      <Tabs.Panel value="portfolio">
        <Card.Wrapper className={clsx('mt-10', classes.card)}>
          <LoadingTable
            agGridProps={{ headerHeight: 60, rowHeight: 44, columnDefs: COLUMN_DEFS }}
            height="400px"
          />
        </Card.Wrapper>
      </Tabs.Panel>
    )
  }

  const { account } = data
  const hasProtection = account.strategy.type === 'TIPP' || account.strategy.type === 'CPPI'

  const rowData = data.account.portfolio.targetWeights.map(targetWeight => {
    const multiplier = hasProtection
      ? `${
          (targetWeight.asset.multiplier as ApiFixedMultiplier).multiplier ||
          (targetWeight.asset.multiplier as ApiVariableMultiplier).standardMultiplier
        }x`
      : '–'
    return {
      assetId: targetWeight.asset.assetId,
      name: targetWeight.asset.name,
      multiplier,
      weight: targetWeight.weight.toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        style: 'percent'
      })
    }
  })

  return (
    <Tabs.Panel value="portfolio">
      <Card.Wrapper className={clsx('mt-10', classes.card)}>
        <Table
          agGridProps={{
            columnDefs: COLUMN_DEFS,
            defaultColDef: DEFAULT_COLUMN_OPTIONS,
            headerHeight: 60,
            rowData,
            rowHeight: 44
          }}
          height="400px"
        />
      </Card.Wrapper>
    </Tabs.Panel>
  )
}
